<template>

  <div>

    <div :id="_uid" class="ui small modal" :class="modalSelector">
      <div class="ui header">
        {{ isCreating ? "Novo Tipo de Exame" : "Alterar Tipo de Exame" }}
      </div>
      <div class="content">
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Descrição <span class="red text">*</span></label>
              <input class="uppercase" v-model="type.description" @blur="type.description = $toUpperCase($event)">
            </div>     
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>      
        <button v-if="isUpdating" class="ui basic red button" 
          :class="{ loading: checkingRemoval || removing, disabled: saving }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button>
        <button class="ui blue button" :class="{ loading: saving, disabled: !type.description || removing }" @click="onConfirm()">
          <i class="checkmark icon"></i>
          {{ isCreating ? "Confirmar" : "Atualizar" }}
        </button>
      </div>
    </div>

    <can-not-remove-modal ref="canNotRemoveModal" />

    <yes-no-modal ref="confirmRemovalModal" :message="'Confirma exclusão do tipo de exame ' + type.description + ' ?'" 
      :danger="true" @onYes="onConfirmRemoval()"/>

  </div>
  
</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"
  import ExamTypeService from "@/services/exam-type-service"

  export default {

    name: "ExamTypeFormModal",

    mixins: [modalDialog],

    data() {
      return {
        type: {},
        service: new ExamTypeService(),
      }
    },
    
    methods: {

      load(type) {

        this.type = {}

        if (type)
          this.type = this.$cloneObject(type)

        this.show()
      },

      async onConfirm() {

        if (this.saving)
          return

        this.saving = true
        
        try {

          if (this.isCreating) {
            await this.service.create(this.type)
          } else {            
            await this.service.update(this.type)            
          }

          this.emit("onSave", this.type)

          this.$msg.success(this.isCreating ? "Tipo de Exame criado com sucesso" : "Tipo de Exame alterado com sucesso")
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.saving = false
        }
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.type)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {

        if (this.removing)
          return

        this.removing = true

        try {

          await this.service.remove(this.type) 

          this.emit("onRemove", this.type)

          this.$msg.success("Tipo de Exame excluído com sucesso")
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.removing = false
        }
      },
    },
  }

</script>
